<template>
    <div v-if="gettext=='1'" class="videobg">
        <!-- <video :poster="`https://p3.udn.com.tw/wish/images/poster/${getsite}.jpg`" controls preload>
            <source :src="`https://p3.udn.com.tw/wish/video/${getsite}.mp4`" type="video/mp4">
        </video> -->
        <iframe :src="getvideo">
        </iframe>
    </div>
</template>

<script>
    export default {
        data(){
            return{
                
            }
        },
        props: {
            text: { type: Array },
        },
        mounted(){

        },
        computed:{
            getsite(){
                return this.$store.state.currentwisher;
            },
            gettext(){
                if(this.text!=undefined) return this.text[0];
                else return "0";
            },
            getvideo(){
                if(this.text!=undefined) return this.text[1];
                else return "";
            }
        },
        methods:{

        },
    }
</script>

<style lang="scss" scoped>
    .videobg{
        width: 100%;
        height: 56.25vw;
        max-height: 100vh;
        @media (min-width: 960px) {
            height: 100vh;
        }
        iframe{
            width: 100%;
            height: 100%;
        }
    }
</style>